import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("C:/git/niem/api/niem-toolbox/layouts/custom.vue")),
  default: defineAsyncComponent(() => import("C:/git/niem/api/niem-toolbox/layouts/default.vue"))
}